import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcumaticaService } from './acumatica.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AcumaticaLoadingDialogComponent } from './loading-indicator/loading-dialog-indicator.component';
import { AcumaticaLoadingSnackbarComponent } from './loading-indicator/loading-snackbar-indicator.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    AcumaticaLoadingDialogComponent,
    AcumaticaLoadingSnackbarComponent
  ],
  providers: [
    HttpClient,
    AcumaticaService
  ],
  exports: [
  ]
})
export class AcumaticaModule { }
